module.exports = __webpack_public_path__ + "static/media/asperges.351b9b5e.svg";